// frontend/src/hooks/useSyncedLocalStorage.js
import { useState, useEffect } from "react";

// localStorage에 저장된 상태와 storage 이벤트를 통해 상태를 동기화하는 커스텀 훅
// 키와 초기값을 받아 현재 값을 반환하며, 값이 변경되면 localStorage에 저장하고 다른 탭에서도 실시간으로 업데이트 하는 훅
export default function useSyncedLocalStorage(key, initialValue) {
  // 초기값을 localStorage에서 읽어오거나 초기값 사용
  const [value, setValue] = useState(() => {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : initialValue;
  });

  // value가 변경될 때마다 localStorage 업데이트
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  // storage 이벤트로 다른 탭에서 저장한 값이 바뀌면 업데이트
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === key) {
        setValue(event.newValue ? JSON.parse(event.newValue) : initialValue);
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [key, initialValue]);

  return [value, setValue];
}
